import classNames from 'classnames';
import { Collapse, Nav, NavItem, NavLink } from 'reactstrap';

import useAppMenuController from './app-menu.controller';

function MenuItem({ item, isActive, onItemClick }) {
    return (
        <NavItem>
            <NavLink
                href={item.path || '#'}
                className={classNames('menu-link sub-menu-link', {
                    active: isActive,
                })}
                onClick={(event) => {
                    event.preventDefault();
                    onItemClick(item);
                }}
            >
                {item.icon ? <i className={classNames(item.icon, 'me-2')} /> : null}
                <span className="menu-text">{item.name}</span>
                {item.badge ? (
                    <span className={classNames('badge', `badge-${item.badge.variant}`, 'ms-auto')}>
                        {item.badge.text}
                    </span>
                ) : null}
            </NavLink>
        </NavItem>
    );
}

function MenuItemWithChildren({ item, isExpanded, isActive, onToggle, onLeafClick, isItemActive, isItemExpanded }) {
    return (
        <NavItem className="menu-item-with-children">
            <div className="d-flex align-items-center">
                <NavLink
                    href="#"
                    className={classNames('menu-link', {
                        active: isActive,
                        expanded: isExpanded,
                    })}
                    onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        onToggle(item.id);
                    }}
                >
                    {item.icon ? <i className={classNames(item.icon, 'me-2')} /> : null}
                    <span className="menu-text">{item.name}</span>
                    {item.badge ? (
                        <span className={classNames('badge', `badge-${item.badge.variant}`, 'ms-auto')}>
                            {item.badge.text}
                        </span>
                    ) : null}
                    <i
                        className={classNames('fas fa-chevron-down ms-auto', {
                            'fa-rotate-180': isExpanded,
                        })}
                    />
                </NavLink>
            </div>

            <Collapse isOpen={isExpanded}>
                <Nav className="sub-menu" vertical>
                    {item.children.map((child) =>
                        child.children ? (
                            <MenuItemWithChildren
                                key={child.id}
                                item={child}
                                isExpanded={isItemExpanded(child)}
                                isActive={isItemActive(child)}
                                onToggle={onToggle}
                                onLeafClick={onLeafClick}
                                isItemActive={isItemActive}
                                isItemExpanded={isItemExpanded}
                            />
                        ) : (
                            <MenuItem
                                key={child.id}
                                item={child}
                                isActive={isItemActive(child)}
                                onItemClick={onLeafClick}
                            />
                        )
                    )}
                </Nav>
            </Collapse>
        </NavItem>
    );
}

export default function AppMenu({ onNavigate }) {
    const {
        isAuthenticated,
        menuItems,
        isItemActive,
        isItemExpanded,
        toggleItem,
        handleLeafClick,
    } = useAppMenuController({ onNavigate });

    if (!isAuthenticated) {
        return null;
    }

    if (!menuItems.length) {
        return (
            <div className="app-menu">
                <Nav className="side-nav vertical-nav" vertical />
            </div>
        );
    }

    return (
        <div className="app-menu">
            <Nav className="side-nav vertical-nav" vertical>
                {menuItems.map((item) =>
                    item.children ? (
                        <MenuItemWithChildren
                            key={item.id}
                            item={item}
                            isExpanded={isItemExpanded(item)}
                            isActive={isItemActive(item)}
                            onToggle={toggleItem}
                            onLeafClick={handleLeafClick}
                            isItemActive={isItemActive}
                            isItemExpanded={isItemExpanded}
                        />
                    ) : (
                        <MenuItem
                            key={item.id}
                            item={item}
                            isActive={isItemActive(item)}
                            onItemClick={handleLeafClick}
                        />
                    )
                )}
            </Nav>
        </div>
    );
}
